import React from 'react'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'
import StyledH5Heading from '../../../common/components/styledH5Heading/StyledH5Heading'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import CharacteristicsCard from '../../../components/characteristicsCard/CharacteristicsCard'
import StyledXsText from '../../../common/components/styledXsText/StyledXsText'
import StyledH2Heading from '../../../common/components/styledH2Heading/StyledH2Heading'

const characteristicsData = [
  {
    tagline: "LOW FEES",
    digits: "$0.01",
    content: "Enjoy the lowest fees - almost zero"
  },
  {
    tagline: "FAST TRANSACTIONS",
    digits: "5 sec",
    content: "Transactions confirmed in seconds."
  },
]

const TechnologySection = () => {
  return (
    <div className='w-[95%] lg:w-[85%] h-full flex flex-col gap-10 lg:gap-32 py-10 lg:py-32'>
      <div className='flex flex-col justify-between gap-10 lg:gap-0 lg:flex-row'>
        <div className='flex flex-col gap-8 w-[95%] lg:w-[60%]'>
          <div>
            <StyledSmText fontColor="text-gray">TECHNOLOGY</StyledSmText>
          </div>
          <div>
            <StyledH5Heading fontColor="text-gradient leading-none">The most trusted way to build value.</StyledH5Heading>
          </div>
          <div className='lg:w-[70%]'>
            <StyledMdText fontColor="text-white">HopeLedger is a state-of-the-art blockchain framework that powers the HopeLedger Hub and its rapidly expanding orbit of sovereign chains.<br /><br /> Developers can use the SDK to build innovative applications that create value through exchange with the HopeLedger Hub.</StyledMdText>
          </div>
        </div>
        <div className='flex flex-col gap-2 lg:w-[40%] text-left items-center justify-center'>
          <div>
            <StyledXsText fontColor="text-gray">PROOF OF STAKE</StyledXsText>
          </div>
          <div>
            <StyledH2Heading fontColor="text-gradient">99%</StyledH2Heading>
          </div>
          <div>
            <StyledXsText fontColor="text-gray">Lower carbon footprint</StyledXsText>
          </div>
        </div>
      </div>
      <div className='flex flex-col items-center gap-10 lg:gap-0 lg:items-start lg:flex-row'>
        {characteristicsData?.map((item, index) => (
          <div className='w-[50%]' key={index}>
            <CharacteristicsCard data={item} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default TechnologySection
